var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1792,
    height: 963,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 265,
    width: 1792,
    height: 963
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-284 -265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.5 514.494C287.5 502.347 297.347 492.5 309.494 492.5L2023.51 492.5C2035.65 492.5 2045.5 502.347 2045.5 514.494L2045.5 1199.51C2045.5 1211.65 2035.65 1221.5 2023.51 1221.5L309.494 1221.5C297.347 1221.5 287.5 1211.65 287.5 1199.51Z",
    stroke: "#BFBFBF",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 410.143 396)"
  }, "She", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 263.542,
    y: 0
  }, "works"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 658.854,
    y: 0
  }, "as a        "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -54.4258,
    y: 242
  }, "teacher"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 290.47,
    y: 242
  }, ": 16.3%")), /*#__PURE__*/React.createElement("path", {
    d: "M355.717 643.874 528.217 643.874 700.717 643.874 700.717 647.874 528.217 647.874 355.717 647.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 355.717 757)"
  }, "model", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 13.5%")), /*#__PURE__*/React.createElement("path", {
    d: "M355.717 762.874 478.717 762.874 601.717 762.874 601.717 766.874 478.717 766.874 355.717 766.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 355.717 876)"
  }, "journalist", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 492.708,
    y: 0
  }, ": 8.4%")), /*#__PURE__*/React.createElement("path", {
    d: "M355.717 881.874 520.05 881.874 684.383 881.874 848.717 881.874 848.717 885.874 684.383 885.874 520.05 885.874 355.717 885.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 355.717 995)"
  }, "lawyer", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 295.625,
    y: 0
  }, ": 8.4%")), /*#__PURE__*/React.createElement("path", {
    d: "M355.717 1000.87 503.717 1000.87 651.717 1000.87 651.717 1004.87 503.717 1004.87 355.717 1004.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 355.717 1115)"
  }, "nurse", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 7.2% ")), /*#__PURE__*/React.createElement("path", {
    d: "M355.717 1120.87 478.717 1120.87 601.717 1120.87 601.717 1124.87 478.717 1124.87 355.717 1124.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393 396 1778.29 396",
    stroke: "#000000",
    strokeWidth: 10.3125,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1173.95 638)"
  }, "waitress", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 394.167,
    y: 0
  }, ": 5.0%")), /*#__PURE__*/React.createElement("path", {
    d: "M1173.95 643.874 1370.95 643.874 1567.95 643.874 1567.95 647.874 1370.95 647.874 1173.95 647.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1173.95 757)"
  }, "doctor", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 295.625,
    y: 0
  }, ": 1.6%")), /*#__PURE__*/React.createElement("path", {
    d: "M1173.95 762.874 1321.95 762.874 1469.95 762.874 1469.95 766.874 1321.95 766.874 1173.95 766.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1173.95 876)"
  }, "secretary", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 443.438,
    y: 0
  }, ": 1.5%")), /*#__PURE__*/React.createElement("path", {
    d: "M1173.95 881.874 1321.62 881.874 1469.29 881.874 1616.95 881.874 1616.95 885.874 1469.29 885.874 1321.62 885.874 1173.95 885.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1173.95 995)"
  }, "coach", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 1.3%")), /*#__PURE__*/React.createElement("path", {
    d: "M1173.95 1000.87 1296.95 1000.87 1419.95 1000.87 1419.95 1004.87 1296.95 1004.87 1173.95 1004.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1173.95 1115)"
  }, "photographer", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 591.25,
    y: 0
  }, ": 1.3% ")), /*#__PURE__*/React.createElement("path", {
    d: "M1173.95 1120.87 1370.95 1120.87 1567.95 1120.87 1764.95 1120.87 1764.95 1124.87 1567.95 1124.87 1370.95 1124.87 1173.95 1124.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1811.53 396)"
  }, "."))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShe);
export default __webpack_public_path__ + "static/media/she.dc8f5927b5a01382592fe86538decde1.svg";
export { ForwardRef as ReactComponent };